/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:24:19
 * @modify date 2021-08-23 11:24:19
 * @desc [枚举]
 */
/**
 * @export 平台枚举
 * @enum x-client-info:platform={平台};version={版本号}
 */
export var EnumPlatforms;
(function (EnumPlatforms) {
    /** 桌面PC */
    EnumPlatforms["desktop"] = "desktop";
    /** 手机H5 */
    EnumPlatforms["mobile"] = "mobile";
    /** 后台管理 */
    EnumPlatforms["bgm"] = "bgm";
    /** 微信小程序 */
    EnumPlatforms["weapp"] = "weapp";
    /** 微信公众号 */
    EnumPlatforms["wechat"] = "wechat";
    /** app */
    EnumPlatforms["app"] = "app";
})(EnumPlatforms || (EnumPlatforms = {}));
/**
 * @export 登陆类型
 * @enum
 */
export var EnumLoginType;
(function (EnumLoginType) {
    /** 手机号 */
    EnumLoginType["mobile"] = "mobile";
    /** 账号 */
    EnumLoginType["account"] = "account";
    /** 微信 */
    EnumLoginType["wechat"] = "wechat";
    /** 注册 */
    EnumLoginType["registered"] = "registered";
})(EnumLoginType || (EnumLoginType = {}));
/**
 * @export 微信授权类型
 * @enum
 */
export var EnumWechatAuthorizeState;
(function (EnumWechatAuthorizeState) {
    /** 授权登录 */
    EnumWechatAuthorizeState["login"] = "login";
})(EnumWechatAuthorizeState || (EnumWechatAuthorizeState = {}));
export var EnumStatusCode;
(function (EnumStatusCode) {
    /** 身份为sales */
    EnumStatusCode[EnumStatusCode["salesAuth"] = 4001] = "salesAuth";
    /** 未认证的l2 */
    EnumStatusCode[EnumStatusCode["L2Auth"] = 4002] = "L2Auth";
    /** 已认证-未绑定k码 l2 */
    EnumStatusCode[EnumStatusCode["bindKcode"] = 4003] = "bindKcode";
    /** 已认证-未绑定手机号 l2 */
    EnumStatusCode[EnumStatusCode["bindMobile"] = 4004] = "bindMobile";
    /** 个人中心-我的商机-sales权限 */
    EnumStatusCode[EnumStatusCode["salesToBu"] = 4005] = "salesToBu";
    /** 服务器错误 */
    EnumStatusCode[EnumStatusCode["serverError"] = 500] = "serverError";
    /** 401错误 未登录 */
    EnumStatusCode[EnumStatusCode["notLogin"] = 401] = "notLogin";
    /** 404错误 */
    EnumStatusCode[EnumStatusCode["notFound"] = 404] = "notFound";
})(EnumStatusCode || (EnumStatusCode = {}));
